import { useState } from 'react'
import { Check, ScanText } from 'lucide-react'
import type { LanguagePack } from '../i18n/packs'
import { MAX_PDF_PAGES } from '../services/ocr'

/** For long PDFs: let the user choose the important pages instead of silently reading everything. */
export function PagePicker({
  p,
  thumbnails,
  onRead
}: {
  p: LanguagePack
  thumbnails: string[]
  onRead: (pages: number[]) => void
}) {
  const [selected, setSelected] = useState<number[]>([1])

  function toggle(page: number) {
    setSelected((current) =>
      current.includes(page)
        ? current.filter((n) => n !== page)
        : current.length >= MAX_PDF_PAGES
        ? current
        : [...current, page].sort((a, b) => a - b)
    )
  }

  return (
    <section className="pages-view">
      <h1 className="screen-title">{p.errLongDocument}</h1>
      <p className="field-hint">{p.pickPagesHint(MAX_PDF_PAGES)}</p>
      <div className="page-grid">
        {thumbnails.map((src, index) => {
          const page = index + 1
          const isSelected = selected.includes(page)
          return (
            <button
              key={page}
              className={`page-thumb ${isSelected ? 'selected' : ''}`}
              onClick={() => toggle(page)}
              aria-pressed={isSelected}
            >
              {src ? <img src={src} alt="" /> : <span className="thumb-placeholder" />}
              <span className="page-label">
                {isSelected && <Check size={16} aria-hidden="true" />} {p.pageLabel(page)}
              </span>
            </button>
          )
        })}
      </div>
      <button className="primary-button big-action sticky-action" disabled={selected.length === 0} onClick={() => onRead(selected)}>
        <ScanText size={24} aria-hidden="true" /> {p.readSelectedPages(selected.length)}
      </button>
    </section>
  )
}
